<!--The content below is only a placeholder and can be replaced.-->
<div class="container pt-4 pb-4">
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <router-outlet></router-outlet>
    </div>
  </div>
</div>
<div class="container">
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
        © 2019 Copyright Myrealkorean
    </div>
  </div>
</div>